import { ISystemEventFiltersState } from './systemEventFilters.atom.ts'
import { ISystemEvent } from './systemEvents.types.ts'

const getTypeText = (type: ISystemEvent['type']) => {
  switch (type) {
    case 'ALARM_SITUATION_INCIDENT':
      return 'Сигнальная ситуация'
    case 'LP_ERROR':
      return 'Ошибка лифта'
    case 'MOVED_TO_MAINTENANCE':
      return 'Режим обслуживания'
    case 'MOVED_FROM_MAINTENANCE_TO_NORMAL':
      return 'Из обслуживания в нормальную работу'
    default:
      return 'Системное'
  }
}

const getParamsListByFilterState = (filterState: ISystemEventFiltersState) => {
  return {
    created_gte: filterState.created_gte ? filterState.created_gte.toISOString() : undefined,
    created_lte: filterState.created_lte ? filterState.created_lte.toISOString() : undefined,
    type__in: filterState.type.join(','),
  }
}

const systemEventsUtils = {
  getTypeText,
  getParamsListByFilterState,
}

export default systemEventsUtils
